import { defineMessages } from 'react-intl';

const promoErrorMessage = defineMessages({
    soldOutHeading: {
        id: 'orderSuccessPage.promoSoldOutLabel',
        description: 'Label for promo sold out.',
        defaultMessage: 'Promo Sold Out'
    },
    soldOutContent: {
        id: 'orderSuccessPage.soldOutText',
        description: 'Text to show when a promo is sold out.',
        defaultMessage: `Whoops! The promotion tied to your order is sold out.
        You can go back and edit your order without the promotion.`
    },
    limitExceedHeading: {
        id: 'orderSuccessPage.promoLimitExceededLabel',
        description: 'Label for promo limit exceeded',
        defaultMessage: 'Promotion Limit is Used Up'
    },
    limitExceedContent: {
        id: 'orderSuccessPage.promoLimitExceededText',
        description: 'Text to show when promo redemption limit has exceeded',
        defaultMessage: `You have already redeemed this promotion.
        Would you like to go back and edit your cart or retry your payment without the promotion?`
    },
    soldOutButtonText: {
        id: 'orderSuccessPage.promoModalEditCartLabel',
        description: 'Label for promo modal edit cart',
        defaultMessage: 'Edit Order'
    },
    limitExceedButtonText: {
        id: 'orderSuccessPage.promoModalCloseLabel',
        description: 'Label for promo modal close button',
        defaultMessage: 'GOT IT'
    },
    promoExpiredContinueText: {
        id: 'promotion.promoMessages.promoExpiredContinueText',
        description: 'Continue text',
        defaultMessage: 'Continue to Check out'
    },
    offerExpiredHeading: {
        id: 'promotion.promoMessages.offerExpiredHeading',
        description: 'offer Expired Heading',
        defaultMessage: 'Offer expired'
    },
    expiredOfferText: {
        id: 'promotion.promoMessages.expiredOfferText',
        description: 'Expired Offer text',
        defaultMessage: 'Expired offer:'
    },
    offerExpiredText: {
        id: 'promotion.promoMessages.offerExpiredText',
        description: 'offer Expired text',
        defaultMessage: 'Sorry, this offer has expired and was removed from your order.'
    },
    NewOfferHeading: {
        id: 'promotion.promoMessages.NewOfferHeading',
        description: 'New offer heading text',
        defaultMessage: 'New offer applied'
    },
    NewOfferAppliedText: {
        id: 'promotion.promoMessages.NewOfferAppliedText',
        description: 'New offer applied text',
        defaultMessage: 'The applied offer has expired and was replaced with another available offer.'
    },
    AppliedOfferText: {
        id: 'promotion.promoMessages.AppliedOfferText',
        description: 'applied Offer text',
        defaultMessage: 'Applied offer:'
    },
    promoLimitedButtonText: {
        id: 'promotion.promoMessages.promoLimitedButtonText',
        description: 'Promo Limited button text',
        defaultMessage: 'Continue without offer'
    },
    promoLimitedBody: {
        id: 'promotion.promoMessages.promoLimitedBody',
        description: 'Promo Limited body text',
        defaultMessage: 'It looks like you already used this offer. You can review your order, or continue to place your order without the offer.'
    },
    promoSoldOutBody: {
        id: 'promotion.promoMessages.promoSoldOutBody',
        description: 'Promo sold out body text',
        defaultMessage: 'This offer has already been redeemed. It was a limited-time deal and is now sold out. '
    },
    reviewOrderButtonText: {
        id: 'promotion.promoMessages.reviewOrderButtonText',
        description: 'Edit Order button text',
        defaultMessage: 'Review order'
    },
    promoLimitedHeading: {
        id: 'promotion.promoMessages.promoLimitedHeading',
        description: 'Promo limited heading',
        defaultMessage: 'Offer already used'
    },
    PromoSoldOutHeading: {
        id: 'promotion.promoMessages.PromoSoldOutHeading',
        description: 'Promo sold Out heading',
        defaultMessage: 'Offer sold out'
    },
    invalidPromoCodeText: {
        id: 'promotion.promoMessages.invalidPromoCodeText',
        description: 'Invalid promo code text',
        defaultMessage: 'The promo code {promoCode} is invalid.'
    },
    promoExhaustedInlineBody: {
        id: 'promotion.promoMessages.promoExhaustedInlineBody',
        description: 'Promo exhausted inline body text',
        defaultMessage: 'Offer no longer available.You\'ve reached the redemption limit for this offer. '
    },
    promoExhaustedHeading: {
        id: 'promotion.promoMessages.promoExhaustedHeading',
        description: 'Promo exhausted heading',
        defaultMessage: 'Offer no longer available'
    },
    promoExhaustedBody: {
        id: 'promotion.promoMessages.promoExhaustedBody',
        description: 'Promo exhausted body text',
        defaultMessage: 'You\'ve reached the usage limit for this offer, so it won\'t be applied. Your order will continue as normal.'
    },
    promoExhaustedButtonText: {
        id: 'promotion.promoMessages.promoExhaustedButtonText',
        description: 'Promo exhausted button text',
        defaultMessage: 'Continue'
    }
});

export default promoErrorMessage;
